// Mirrors backend `caller_email()` in support/auth.py. Cognito's id_token
// shape varies for SAML-federated users — `email` is only present when the
// IdP attribute mapping wired it up. Fall back through SAML NameID
// (identities[].userId) and `cognito:username`.

type Identity = { userId?: string };

export function deriveCallerEmail(profile: Record<string, unknown> | undefined): string | null {
  if (!profile) return null;

  const direct = profile["email"];
  if (typeof direct === "string" && direct.trim()) return direct.trim();

  const rawIdentities = profile["identities"];
  let identities: Identity[] = [];
  if (Array.isArray(rawIdentities)) {
    identities = rawIdentities as Identity[];
  } else if (typeof rawIdentities === "string") {
    try {
      const parsed = JSON.parse(rawIdentities);
      if (Array.isArray(parsed)) identities = parsed;
    } catch {
      // not JSON — ignore
    }
  }
  for (const ident of identities) {
    const uid = ident?.userId;
    if (typeof uid === "string" && uid.includes("@")) return uid.trim();
  }

  const username = profile["cognito:username"];
  if (typeof username === "string" && username.trim()) {
    const cleaned = username.trim();
    if (cleaned.includes("_")) {
      const tail = cleaned.split("_").slice(1).join("_");
      if (tail.includes("@")) return tail;
    }
    return cleaned;
  }

  return null;
}
